import { render, staticRenderFns } from "./PromoOne.vue?vue&type=template&id=b935dcf8&scoped=true"
import script from "./PromoOne.vue?vue&type=script&lang=js"
export * from "./PromoOne.vue?vue&type=script&lang=js"
import style0 from "./PromoOne.vue?vue&type=style&index=0&id=b935dcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b935dcf8",
  null
  
)

export default component.exports